import StyledHeading from '@/components/StyledHeading'
import CONTENT from '@/constants/content'
import { Box, Dialog, Image } from 'pcln-design-system'
import Form from './SearchForm/Form'
import { handleSubmitForExpressDealsCars } from './SearchForm/utils'

const expressDealLogo = 'https://s1.pclncdn.com/design-assets/brand-assets/express-deals-logo-registard.svg'

export default function ExpressDealDialog({
  isOpen,
  closeDialog,
  isMobile,
}: Readonly<{
  isMobile?: boolean
  isOpen: boolean
  closeDialog: () => void
}>) {
  const mobileProps = {
    sheet: true,
    fullWidth: true,
    headerShowCloseButton: true,
    headerContent: '  ',
    showCloseButton: false,
  } as const
  const dialogProps = isMobile ? mobileProps : ({ overflowY: 'visible', overflowX: 'visible' } as const)
  return (
    <Dialog
      open={isOpen}
      ariaDescription='Search for Express Deals'
      ariaTitle='Rental Car Express Deal Dialog'
      borderRadius='2xl'
      onOpenChange={closeDialog}
      scrimColor='dark'
      innerContentOverflow='visible'
      scrimDismiss
      size={isMobile ? 'full' : 'md'}
      {...dialogProps}
    >
      <Box pt={[null, null, null, 3]} pb={2} px={3}>
        <Image src={expressDealLogo} height='24px' width='164px' alt='' />
        <StyledHeading
          text={CONTENT.homepage.cars.expressDeals.headline}
          fontSize={[3, null, null, 4]}
          lineHeight='display'
          tag='h2'
        />
        <Box pt={2}>
          <Form onSubmit={handleSubmitForExpressDealsCars} promoDeal />
        </Box>
      </Box>
    </Dialog>
  )
}
